import { addMilliseconds } from 'date-fns';
import { projectDeletionTime } from '../constants/ProjectDeletionTime';

export const getProjectDeletionDate = (referenceDate: Date) => {
  return addMilliseconds(referenceDate, projectDeletionTime);
};
